import { render, staticRenderFns } from "./FortuneWheel.vue?vue&type=template&id=7c35edfe&scoped=true&"
import script from "./FortuneWheel.vue?vue&type=script&lang=js&"
export * from "./FortuneWheel.vue?vue&type=script&lang=js&"
import style0 from "./FortuneWheel.vue?vue&type=style&index=0&id=7c35edfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c35edfe",
  null
  
)

export default component.exports